import { render, staticRenderFns } from "./MemberSpace.vue?vue&type=template&id=2cadc27e&scoped=true"
import script from "./MemberSpace.vue?vue&type=script&lang=js"
export * from "./MemberSpace.vue?vue&type=script&lang=js"
import style0 from "./MemberSpace.vue?vue&type=style&index=0&id=2cadc27e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadc27e",
  null
  
)

export default component.exports